import { call, put, takeLatest, select } from 'redux-saga/effects';
import { saveLoadedContentByCatSlug } from './actions';
import { LOAD_CONTENT_BY_CAT_SLUG } from './constants';

import { templateService } from '~/services';

function* loadContentByCatSlug(action) {
  const { catSlug, page, pageSize } = action.payload;
  try {
    const data = yield call(templateService.listTemplates, {
      categorySlug: catSlug,
      page: page || 1,
      max_results: pageSize,
    });
    // console.log('dataaaaaaaaaaaaa', data);

    // // Normalize data for static page
    // data.templates.forEach((item) => {
    //   item.workarea_unit = item.workarea_unit || 'px';
    // });

    yield put(saveLoadedContentByCatSlug(data));
  } catch (error) {
    console.log('--- 4111111111 ---');
    console.log(error);
  }
}

export default function* categorySaga() {
  yield takeLatest(LOAD_CONTENT_BY_CAT_SLUG, loadContentByCatSlug);
}
